/* @refresh reset */
import { useState, useEffect, useCallback, useMemo } from "react";
import { supabase } from "@/integrations/supabase/client";

interface Service {
  id: string;
  label: string;
  display_order: number;
  active: boolean;
}

// Fallback services in case DB is unavailable
const FALLBACK_SERVICES: Service[] = [
  { id: "racunovodstvo", label: "Računovodstvo", display_order: 1, active: true },
  { id: "poslovno-svetovanje", label: "Poslovno svetovanje", display_order: 2, active: true },
  { id: "prodaja", label: "Prodaja", display_order: 3, active: true },
  { id: "marketing", label: "Marketing", display_order: 4, active: true },
  { id: "delavnice", label: "Delavnice", display_order: 5, active: true },
  { id: "razpisi", label: "Razpisi", display_order: 6, active: true },
  { id: "esop", label: "ESOP", display_order: 7, active: true },
  { id: "drugo", label: "Drugo", display_order: 8, active: true },
];

export const useServices = () => {
  const [services, setServices] = useState<Service[]>(FALLBACK_SERVICES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      const { data, error } = await supabase
        .from("cms_services")
        .select("*")
        .eq("active", true)
        .order("display_order", { ascending: true });

      if (!error && data && data.length > 0) {
        setServices(data);
      }
      setLoading(false);
    };

    fetchServices();
  }, []);

  // Get label by ID (handles both UUID ids and legacy string ids)
  const getServiceLabel = useCallback((serviceId: string): string => {
    const service = services.find((s) => s.id === serviceId);
    if (service) return service.label;
    // Fallback: if serviceId looks like a label, return it as-is
    return serviceId;
  }, [services]);

  const serviceLabels = useMemo(() => services.map((s) => s.label), [services]);

  return { 
    services, 
    loading, 
    serviceLabels,
    getServiceLabel 
  };
};
